import { gspx } from '@rsos/gainsight';

const CENTRAL_STATION = 'central_station';

export const trackLogOutClick = (currentApp, irpVersion) => {
  const appName = currentApp === CENTRAL_STATION ? 'CSP' : 'RSP';

  gspx.trackCustomEvent('Auth', {
    irpVersion,
    name: `user clicks on logout button from error in ${appName}`,
    Category: 'Auth',
    'Launched date': new Date(),
  });
};
